// extracted by mini-css-extract-plugin
module.exports = {"rating":"_3ns_KO","fullStar":"_2rchro","halfStar":"_1km-F6","emptyStar":"q4hasp"};